export const isCodeSecure = (code) => {
  // Evitar repetición del mismo dígito (ej: 000000, 111111)
  if (/^(\d)\1{5}$/.test(code)) return false;
  
  // Evitar patrones inseguros conocidos
  const badPatterns = [
    '123456', '654321', '012345', '543210', 
    '112233', '121212', '987654', '123123'
  ];
  if (badPatterns.includes(code)) return false;
  
  return true;
};

export const generateSecureCode = (allHistoricalCodes = []) => {
  let code;
  let attempts = 0;
  
  do {
    // Generar un número aleatorio entre 0 y 999999 y padding con 0s
    code = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
    attempts++;
    
    // Fallback de seguridad por si el bucle se atasca
    if (attempts > 5000) break;
  } while (!isCodeSecure(code) || allHistoricalCodes.includes(code));
  
  return code;
};